import { gql } from '@apollo/client';

export const CREATE_PUBLIC_OFFERING = gql`
  mutation CreatePublicOffering(
    $listingId: ID!
    $allowBanks: Boolean!
    $allowCreditUnions: Boolean!
    $allowPrivateCapital: Boolean!
    $executionType: ExecutionType!
    $expirationDate: DateTime!
    $isPublic: Boolean!
    $isServicingNegotiable: Boolean!
    $performanceClass: PerformanceClass!
    $pricingType: PricingType!
    $pricingRate: Int
    $servicingPreference: ServicingPreference!
    $servicingFeeRate: Int
    $selectedDocuments: [ID!]!
    $minimumCarve: Int!
    $participationRate: Int
    $isParticipationNegotiable: Boolean
  ) {
    createPublicOffering(
      input: {
        listing_id: $listingId
        allow_banks: $allowBanks
        allow_credit_unions: $allowCreditUnions
        allow_private_capital: $allowPrivateCapital
        execution_type: $executionType
        expiration_date: $expirationDate
        is_public: $isPublic
        is_servicing_negotiable: $isServicingNegotiable
        performance_class: $performanceClass
        pricing_type: $pricingType
        pricing_rate_bps: $pricingRate
        servicing_preference: $servicingPreference
        servicing_fee_rate_bps: $servicingFeeRate
        template_document_ids: $selectedDocuments
        minimum_carve_cents: $minimumCarve
        participation_rate: $participationRate
        is_participation_negotiable: $isParticipationNegotiable
      }
    ) {
      ... on PublicListing {
        __typename
        id
        loan_count
      }
      ... on OfferingCreationJob {
        __typename
        job_id
        job_type
        status
        progress_percentage
        processed_count
        estimated_count
        offering_name
        pool_id
      }
    }
  }
`;
